/* ZCT_V21_JOURNAL_IG (03.10.2026, Kacheln 05.10.): Instagram-Karten im Journal, Verhalten wie im bisherigen Journal.
   In den Kacheln der Übersicht (data-zct-ig-mode="tile") öffnet ein Tipp auf Bild oder Video den Beitrag.
   Karussell (Pfeile, Zähler, Punkte, Wischen), Reels (spielen stumm, sobald sichtbar; Ton per Knopf;
   bei „Bewegung reduzieren“ erst nach Tippen auf Abspielen),
   Live-Daten (Video, Likes, Kommentare, neue Beiträge) über denselben Instagram-Dienst wie die Startseite.
   Ohne Live-Daten bleiben die Ersatzbilder aus dem Theme stehen. */
(function () {
  "use strict";
  if (window.__zctJournalIg) return;
  window.__zctJournalIg = true;

  var API = "https://zincutec-preview.pages.dev/api/instagram-feed";
  function zctT(k) { try { var el = document.getElementById('zct-texte'), d = el ? JSON.parse(el.textContent) : {}; var v = d[k]; if (typeof v === 'string' && v.indexOf('&') >= 0) { var t = document.createElement('textarea'); t.innerHTML = v; v = t.value; } return v == null ? '' : v; } catch (e) { return ''; } }
  var T = { play: zctT("v25_video_abspielen"), on: zctT("v25_ton_an"), off: zctT("v25_ton_aus"), prev: zctT("v25_bild_vorher"), next: zctT("v25_bild_naechstes"), img: zctT("v25_bild"), of: zctT("v25_von") };
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
  var SVG_PLAY = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="8,5 19,12 8,19"/></svg>';
  var SVG_MUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H3v6h3l5 4V5z"/><path d="M22 9l-6 6"/><path d="M16 9l6 6"/></svg>';
  var SVG_SOUND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H3v6h3l5 4V5z"/><path d="M15.5 8.5a5 5 0 010 7"/><path d="M18.5 5.5a9 9 0 010 13"/></svg>';
  var SVG_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var SVG_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function codeFrom(url) {
    var m = String(url || "").match(/\/(?:p|reel|reels|tv)\/([^/?#]+)/);
    return m ? m[1] : "";
  }
  function clampRatio(r) { return Math.max(0.55, Math.min(1.95, r || 1)); }
  function fmt(n) {
    try { return Number(n).toLocaleString(zctT("v25_intl_zahl")); } catch (e) { return String(n); }
  }
  function captionPreview(caption) {
    var line = String(caption || "").split(/\n+/).map(function (x) { return x.trim(); }).filter(Boolean)[0] || "";
    line = line.replace(/#\S+/g, "").replace(/\s+/g, " ").replace(/[.…]+$/, "").trim();
    return line ? line + "..." : "";
  }
  function button(cls, label, svg) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = cls;
    b.setAttribute("aria-label", label);
    b.innerHTML = svg;
    return b;
  }
  function stopAll(e) { e.preventDefault(); e.stopPropagation(); }

  /* Seitenverhältnis und Kartenbreite wie im bisherigen Journal */
  function setRatio(host, ratio) {
    if (host.getAttribute("data-zct-ig-mode") === "tile") return;
    var r = clampRatio(ratio);
    if (host.getAttribute("data-zct-ig-mode") === "overview") {
      host.style.setProperty("--media-ratio", r);
      var card = host.closest(".blog-overview-card");
      if (card) card.style.setProperty("--ig-card-w", Math.round(Math.max(350, Math.min(540, 480 * r))) + "px");
      return;
    }
    var igCard = host.closest(".blog-article-ig-card");
    if (!igCard) return;
    var w = Math.round(Math.max(320, Math.min(390, 390 * r))) + "px";
    igCard.style.setProperty("--ig-card-w", w);
    igCard.style.setProperty("--blog-article-card-w", w);
    igCard.style.setProperty("--media-ratio", r);
  }

  /* Karussell */
  function initCarousel(car) {
    if (!car || car.__zctIg) return;
    car.__zctIg = true;
    var scroller = car.querySelector(".ig-carousel-scroll");
    var slides = car.querySelectorAll(".ig-carousel-slide");
    var total = slides.length;
    var count = car.querySelector("[data-zct-ig-n]");
    var dots = car.querySelectorAll(".ig-carousel-dots span");
    var prev = car.querySelector(".ig-carousel-prev");
    var next = car.querySelector(".ig-carousel-next");
    var active = 0;
    if (!car.closest('[data-zct-ig-mode="tile"]')) car.addEventListener("click", function (e) { e.stopPropagation(); });
    if (!scroller || total < 2) return;

    function render(i) {
      active = i;
      if (count) count.textContent = String(i + 1);
      each(dots, function (d, k) { d.className = k === i ? "active" : ""; });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === total - 1;
    }
    function sync() {
      var i = Math.max(0, Math.min(total - 1, Math.round(scroller.scrollLeft / Math.max(1, scroller.clientWidth))));
      if (i !== active) render(i);
    }
    function go(i, e) {
      if (e) stopAll(e);
      var target = Math.max(0, Math.min(total - 1, i));
      render(target);
      // Plan 014: per Tastatur sofort (Emil: Tastatur-Aktionen nicht animieren), per Klick/Wischen weich
      scroller.scrollTo({ left: scroller.clientWidth * target, behavior: (e && e.type === "keydown") ? "instant" : (reduceMotion && reduceMotion.matches ? "auto" : "smooth") });
    }
    var queued = false;
    scroller.addEventListener("scroll", function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sync(); });
    }, { passive: true });
    if (prev) prev.addEventListener("click", function (e) { go(active - 1, e); });
    if (next) next.addEventListener("click", function (e) { go(active + 1, e); });
    car.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") go(active - 1, e);
      if (e.key === "ArrowRight") go(active + 1, e);
    });
    var first = slides[0] && slides[0].querySelector("img");
    var host = car.closest("[data-zct-ig]");
    if (first && host) {
      var report = function () { if (first.naturalWidth && first.naturalHeight) setRatio(host, first.naturalWidth / first.naturalHeight); };
      if (first.complete) report(); else first.addEventListener("load", report, { once: true });
    }
    render(0);
  }

  function buildCarousel(host, children, alt) {
    var slides = children.map(function (c) {
      return { src: c.media_type === "VIDEO" ? (c.thumbnail_url || c.media_url) : (c.media_url || c.thumbnail_url) };
    }).filter(function (s) { return s.src; });
    if (slides.length < 2) return false;
    var car = document.createElement("div");
    car.className = "ig-carousel";
    var scroller = document.createElement("div");
    scroller.className = "ig-carousel-scroll";
    var track = document.createElement("div");
    track.className = "ig-carousel-track";
    slides.forEach(function (s, i) {
      var slide = document.createElement("div");
      slide.className = "ig-carousel-slide";
      var img = document.createElement("img");
      img.className = "ig-media";
      img.loading = i === 0 ? "eager" : "lazy"; // erstes Bild sofort: auf der Journal-Übersicht ist es das größte Bild im ersten Bildschirm
      img.decoding = "async";
      img.draggable = false;
      img.alt = (alt || "Instagram") + ", " + T.img + " " + (i + 1) + " " + T.of + " " + slides.length;
      // weitere Bilder (Instagram-Originale, bis 3 MB) erst, wenn das Karussell sichtbar wird (oder berührt, überfahren, fokussiert, gewischt)
      if (i === 0) img.src = s.src; else img.setAttribute("data-zd-src", s.src);
      slide.appendChild(img);
      track.appendChild(slide);
    });
    scroller.appendChild(track);
    car.appendChild(scroller);
    var geweckt = false;
    function wecken() { if (geweckt) return; geweckt = true; car.querySelectorAll("img[data-zd-src]").forEach(function (im) { im.src = im.getAttribute("data-zd-src"); im.removeAttribute("data-zd-src"); }); }
    ["pointerenter", "touchstart", "focusin"].forEach(function (t) { car.addEventListener(t, wecken, { passive: true }); });
    if ("IntersectionObserver" in window) { var sicht = new IntersectionObserver(function (es) { if (es[0] && es[0].isIntersecting) { sicht.disconnect(); wecken(); } }, { threshold: 0.25 }); sicht.observe(car); } else wecken();
    scroller.addEventListener("scroll", wecken, { passive: true });
    var count = document.createElement("div");
    count.className = "ig-carousel-count";
    count.setAttribute("aria-hidden", "true");
    count.innerHTML = '<span data-zct-ig-n>1</span>/' + slides.length;
    car.appendChild(count);
    var prev = button("ig-carousel-btn ig-carousel-prev", T.prev, SVG_PREV);
    prev.disabled = true;
    car.appendChild(prev);
    car.appendChild(button("ig-carousel-btn ig-carousel-next", T.next, SVG_NEXT));
    var dots = document.createElement("div");
    dots.className = "ig-carousel-dots";
    dots.setAttribute("aria-hidden", "true");
    slides.slice(0, 8).forEach(function (s, i) {
      var d = document.createElement("span");
      if (i === 0) d.className = "active";
      dots.appendChild(d);
    });
    car.appendChild(dots);
    host.innerHTML = "";
    host.appendChild(car);
    initCarousel(car);
    return true;
  }

  /* Reels: spielen stumm, sobald mehr als ein Drittel sichtbar ist; nur ein Video hat Ton */
  var videoObserver = null;
  var videoState = typeof WeakMap === "function" ? new WeakMap() : null;
  function observeVideo(v, state) {
    if (!videoState) return;
    videoState.set(v, state);
    if (!videoObserver && "IntersectionObserver" in window) {
      videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var st = videoState.get(entry.target);
          if (!st) return;
          st.visible = entry.isIntersecting && entry.intersectionRatio > 0.35;
          if (st.visible) {
            if (!(reduceMotion && reduceMotion.matches)) st.tryPlay();
          } else if (!entry.target.paused) entry.target.pause();
        });
      }, { threshold: [0, 0.35, 0.7] });
    }
    if (videoObserver) videoObserver.observe(v);
  }
  document.addEventListener("visibilitychange", function () {
    each(document.querySelectorAll("video[data-zct-ig-video]"), function (v) {
      var st = videoState && videoState.get(v);
      if (!st) return;
      if (document.hidden) { if (!v.paused) v.pause(); } else if (!(reduceMotion && reduceMotion.matches)) st.tryPlay();
    });
  });

  function initVideo(host, src, poster) {
    if (!src || host.querySelector("video[data-zct-ig-video]")) return;
    var old = host.querySelector("img.ig-media");
    var fallbackPoster = (old && (old.currentSrc || old.src)) || poster || "";
    var v = document.createElement("video");
    v.className = "ig-media";
    v.setAttribute("data-zct-ig-video", "");
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute("muted", "");
    v.loop = true;
    v.playsInline = true;
    v.setAttribute("playsinline", "");
    v.preload = "none";
    if (fallbackPoster) v.poster = fallbackPoster;
    v.src = src;
    if (old) host.replaceChild(v, old); else host.insertBefore(v, host.firstChild);

    var play = host.querySelector(".ig-play-center") || host.appendChild(button("ig-play-center", T.play, SVG_PLAY));
    var sound = host.querySelector(".ig-sound") || host.appendChild(button("ig-sound", T.on, SVG_MUTED));
    play.hidden = false;
    sound.hidden = false;

    var state = { visible: false };
    state.tryPlay = function () {
      if (!state.visible || document.hidden) return;
      var p = v.play();
      if (p && p.catch) p.catch(function () { play.hidden = false; });
    };
    function setMuted(m) {
      v.muted = m;
      sound.setAttribute("aria-label", m ? T.on : T.off);
      sound.innerHTML = m ? SVG_MUTED : SVG_SOUND;
    }
    v.addEventListener("play", function () { play.hidden = true; });
    v.addEventListener("pause", function () { play.hidden = false; });
    v.addEventListener("loadedmetadata", function () {
      if (v.videoWidth && v.videoHeight) setRatio(host, v.videoWidth / v.videoHeight);
    });
    v.addEventListener("stalled", function () { setTimeout(function () { if (v.paused) state.tryPlay(); }, 1000); });
    v.addEventListener("error", function () {
      if (!fallbackPoster) return;
      var img = document.createElement("img");
      img.className = "ig-media";
      img.alt = "";
      img.src = fallbackPoster;
      if (v.parentNode) v.parentNode.replaceChild(img, v);
      play.hidden = true;
      sound.hidden = true;
    });
    if (host.getAttribute("data-zct-ig-mode") !== "tile") {
      v.addEventListener("click", function (e) {
        stopAll(e);
        if (v.paused) { state.visible = true; state.tryPlay(); } else v.pause();
      });
    }
    play.addEventListener("click", function (e) {
      stopAll(e);
      state.visible = true;
      state.tryPlay();
    });
    sound.addEventListener("click", function (e) {
      stopAll(e);
      var nextMuted = !v.muted;
      setMuted(nextMuted);
      if (!nextMuted) {
        window.dispatchEvent(new CustomEvent("zincutec:instagram-audio-on", { detail: { video: v } }));
        if (v.paused) { state.visible = true; state.tryPlay(); }
      }
    });
    window.addEventListener("zincutec:instagram-audio-on", function (e) {
      if (e.detail && e.detail.video === v) return;
      if (!v.muted) setMuted(true);
    });
    observeVideo(v, state);
  }

  /* Live-Daten eintragen */
  function applyLive(host, item) {
    var type = item.media_type || "IMAGE";
    var kids = (item.children && (item.children.data || item.children)) || [];
    var card = host.closest(".blog-article-ig-card");
    var wrap = host.closest("[data-zct-ig-pending]");
    var alt = (host.querySelector("img.ig-media") || {}).alt || "Instagram";

    if (card) {
      var likes = card.querySelector("[data-zct-ig-likes]");
      var comments = card.querySelector("[data-zct-ig-comments]");
      var caption = card.querySelector("[data-zct-ig-caption]");
      if (likes && item.like_count > 0) { likes.textContent = fmt(item.like_count); likes.hidden = false; }
      if (comments && item.comments_count > 0) { comments.textContent = fmt(item.comments_count); comments.hidden = false; }
      var text = captionPreview(item.caption);
      if (caption && text) caption.textContent = text;
    }

    if (type === "VIDEO" && item.media_url) {
      if (!host.querySelector("img.ig-media")) {
        var img = document.createElement("img");
        img.className = "ig-media";
        img.alt = "";
        if (item.thumbnail_url) img.src = item.thumbnail_url;
        host.insertBefore(img, host.firstChild);
      }
      initVideo(host, item.media_url, item.thumbnail_url);
    } else if (type === "CAROUSEL_ALBUM") {
      if (!host.querySelector(".ig-carousel") && !buildCarousel(host, kids, alt) && item.media_url && !host.querySelector("img.ig-media")) {
        var single = document.createElement("img");
        single.className = "ig-media";
        single.alt = alt;
        single.src = item.media_url;
        host.appendChild(single);
      }
    } else if (item.media_url && !host.querySelector("img.ig-media")) {
      var pic = document.createElement("img");
      pic.className = "ig-media";
      pic.alt = alt;
      pic.src = item.media_url;
      pic.addEventListener("load", function () { setRatio(host, pic.naturalWidth / pic.naturalHeight); }, { once: true });
      host.appendChild(pic);
    }
    if (wrap && host.querySelector(".ig-media")) {
      wrap.hidden = false;
      wrap.removeAttribute("data-zct-ig-pending");
    }
  }

  function loadLive() {
    var hosts = document.querySelectorAll("[data-zct-ig]");
    if (!hosts.length || !window.fetch) return;
    var codes = [];
    each(hosts, function (h) {
      var c = h.getAttribute("data-zct-ig");
      if (c && codes.indexOf(c) < 0) codes.push(c);
    });
    if (!codes.length) return;
    fetch(API + "?shortcodes=" + encodeURIComponent(codes.join(",")) + "&limit=100&comments=0&pages=25", {
      headers: { Accept: "application/json" },
      cache: "no-store"
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error("journal-instagram-unavailable")); })
      .then(function (data) {
        var byCode = {};
        (data.items || data.data || []).forEach(function (it) {
          var c = codeFrom(it.permalink);
          if (c) byCode[c] = it;
        });
        each(hosts, function (h) {
          var it = byCode[h.getAttribute("data-zct-ig")];
          if (it) {
            try { applyLive(h, it); } catch (e) { /* Ersatzbild bleibt stehen */ }
          }
        });
      })
      .catch(function () { /* Ersatzbilder bleiben stehen */ });
  }

  /* Übersicht: Klick auf die Karte öffnet den Beitrag (Medien und Knöpfe ausgenommen) */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var tile = t.closest(".zct-j-card[data-zct-href]");
    if (tile) {
      if (t.closest("a, button")) return;
      window.location.href = tile.getAttribute("data-zct-href");
      return;
    }
    var card = t.closest(".blog-overview-card[data-zct-href]");
    if (!card || t.closest("a, button, video, .ig-carousel")) return;
    window.location.href = card.getAttribute("data-zct-href");
  });

  function init() {
    each(document.querySelectorAll("[data-zct-ig-carousel]"), initCarousel);
    each(document.querySelectorAll("[data-zct-ig] img.ig-media"), function (img) {
      var host = img.closest("[data-zct-ig]");
      if (!host || host.querySelector(".ig-carousel")) return;
      var report = function () { if (img.naturalWidth && img.naturalHeight) setRatio(host, img.naturalWidth / img.naturalHeight); };
      if (img.complete) report(); else img.addEventListener("load", report, { once: true });
    });
    loadLive();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
